import {
  Container,
  Grid,
  Box,
  ButtonBase,
  makeStyles,
  Card,
  CardMedia,
  Hidden,
  useTheme,
  Slide,
  Fade,
  Grow,
  Typography,
  useMediaQuery
} from "@material-ui/core";
import { useState, useEffect } from "react";
import parse from "react-html-parser";
import Axios from "axios";
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import { Loading } from "../../components/shared/loading";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    backgroundImage: 'linear-gradient(rgba(76, 0, 76, 0.85), rgba(76, 0, 76, 0.9)), url("/static/whats_new.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    minHeight: "35vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroContent: {
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    textShadow: "0 2px 15px rgba(0,0,0,0.3)",
  },
  heroDivider: {
    width: 40,
    height: 2,
    background: "rgba(255,255,255,0.5)",
    margin: "12px auto",
    borderRadius: 2,
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
  },
  section: {
    padding: "40px 0",
    background: "#fafafa",
  },
  sectionTitle: {
    fontSize: "1.4rem",
    fontWeight: 600,
    color: "#4c004c",
    textAlign: "center",
    marginBottom: 8,
  },
  sectionSubtitle: {
    fontSize: "0.85rem",
    color: "#666666",
    textAlign: "center",
    maxWidth: 450,
    margin: "0 auto 28px",
    lineHeight: 1.5,
  },
  cardLink: {
    width: "100%",
    display: "block",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
    "& *": {
      textDecoration: "none",
    },
  },
  articleCard: {
    background: "#ffffff",
    borderRadius: "16px",
    overflow: "hidden",
    height: "100%",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    cursor: "pointer",
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 20px 40px rgba(107, 27, 107, 0.15)",
    },
    "&:hover $articleImageWrapper img": {
      transform: "scale(1.05)",
    },
  },
  articleImageWrapper: {
    position: "relative",
    width: "100%",
    paddingTop: "56.25%",
    overflow: "hidden",
    backgroundColor: "#f8f4f8",
  },
  articleImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "contain",
    transition: "transform 0.4s ease",
    padding: 8,
  },
  articleContent: {
    padding: "20px",
  },
  articleDate: {
    fontSize: "0.7rem",
    color: "#6b1b6b",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    marginBottom: 8,
  },
  articleTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#1a1a1a",
    marginBottom: 10,
    lineHeight: 1.4,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  articleExcerpt: {
    fontSize: "0.85rem",
    color: "#666666",
    lineHeight: 1.6,
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
  },
  readMore: {
    fontSize: "0.8rem",
    color: "#6b1b6b",
    fontWeight: 600,
    marginTop: 16,
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    transition: "gap 0.2s ease",
    "&:hover": {
      gap: 8,
    },
  },
  noArticles: {
    textAlign: "center",
    padding: "60px 20px",
    color: "#666666",
    fontSize: "0.9rem",
  },
  quoteSection: {
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    borderRadius: "16px",
    padding: "40px 32px",
    marginTop: 48,
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%)",
      pointerEvents: "none",
    },
  },
  quoteText: {
    fontSize: "1rem",
    color: "#ffffff",
    lineHeight: 1.7,
    fontStyle: "italic",
    maxWidth: 700,
    margin: "0 auto 16px",
    position: "relative",
    zIndex: 1,
  },
  quoteAuthor: {
    color: "#ffffff",
    fontSize: "0.85rem",
    fontWeight: 600,
    opacity: 0.9,
    position: "relative",
    zIndex: 1,
  },
}));
  
  export const WhatsNew = () => {
    const theme = useTheme();
    const isMatch = useMediaQuery(theme.breakpoints.down("md"));
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [metaTitle, setMetaTitle] = useState("");
    const [metaDesc, setMetaDesc] = useState("");
    const [metaKeywords, setMetaKeywords] = useState("");
    const [isloading, setIsloading] = useState(true);
  
    const handleClick = () => {
      const anchor = document.querySelector("#back-to-top-anchor");
  
      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };
  
    useEffect(() => {
      getMetaData();
    }, []);
  
    const getMetaData = async() => {
      const formData = new FormData();
      formData.append("page", 7);
      await Axios.post("/api/getmetadata", formData, {
        headers: { headKey: headKey },
      }).then((res) => {
        if (res.data.status) {
          setMetaTitle(res.data.data.meta_title);
          setMetaKeywords(res.data.data.meta_keywords);
          setMetaDesc(res.data.data.meta_desc);
          
          handleClick();
        }
      });
     

      await  Axios
      .post(
        "/api/get_all_articles",
        {
            headers: { headKey: headKey },
          }
      )
      .then((res) => {
        if (res.data.status === true) {
          setData(res.data.data);
        //   setLoading(false);
          console.log(res.data.data);
          setIsloading(false);
        }
      });
    };
    const createSlug = (title) => {
        return title
            .toLowerCase() // Convert to lowercase
            .replace(/[^\w ]+/g, '') // Remove all non-word chars
            .replace(/ +/g, '-'); // Replace spaces with hyphens
    };

      
    return (
      <div>
        <Helmet>
          <title>{metaTitle}</title>
          <meta name="description" content={metaDesc} />
          <meta name="keywords" content={metaKeywords}></meta>
        </Helmet>
        {/* Hero Section */}
        <Box className={classes.heroSection}>
          <Fade in={true} timeout={1000}>
            <Box className={classes.heroContent}>
              <Typography className={classes.heroTitle}>
                What's New
              </Typography>
              <Box className={classes.heroDivider} />
              <Typography className={classes.heroSubtitle}>
                Tech Updates & Media Highlights from Arawinz
              </Typography>
            </Box>
          </Fade>
        </Box>

        {isloading ? (
          <Loading />
        ) : (
          <Box className={classes.section}>
            <Container maxWidth="lg">
              <Slide direction="up" in={true} timeout={800}>
                <Box>
                  <Typography className={classes.sectionTitle}>
                    Latest Updates
                  </Typography>
                  <Typography className={classes.sectionSubtitle}>
                    Discover the latest in IT innovations and media spotlights
                  </Typography>
                </Box>
              </Slide>
              {data.length !== 0 ? (
              <Grid container spacing={4}>
                {data.map((article, index) => {
                  const slug = createSlug(article.article_title);
                  const firstImage = article.article_images.split(",")[0];
                  return (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <Grow in={true} timeout={600 + index * 100}>
                        <Link
                          to={`/article-details/${slug}/${article.article_id}`}
                          className={classes.cardLink}
                        >
                          <Card className={classes.articleCard}>
                            <Box className={classes.articleImageWrapper}>
                              <img
                                src={`/static/articles/${firstImage}`}
                                alt={article.article_title}
                                className={classes.articleImage}
                              />
                            </Box>
                            <Box className={classes.articleContent}>
                              <Typography className={classes.articleDate}>
                                {article.article_published_date_text}
                              </Typography>
                              <Typography className={classes.articleTitle}>
                                {article.article_title}
                              </Typography>
                              <Typography className={classes.articleExcerpt}>
                                {parse(article.article_desc.slice(0, 150).concat("..."))}
                              </Typography>
                              <Typography className={classes.readMore}>
                                Read More <span style={{ marginLeft: 4 }}>→</span>
                              </Typography>
                            </Box>
                          </Card>
                        </Link>
                      </Grow>
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <Box className={classes.noArticles}>
                <Typography>No articles available at the moment.</Typography>
              </Box>
            )}

            {/* Quote Section */}
            <Fade in={true} timeout={1200}>
              <Box className={classes.quoteSection}>
                <Typography className={classes.quoteText}>
                  "At Arawinz Soft Solutions, we are at the forefront, crafting the future. Each update is a testament to our journey towards excellence, transforming ideas into cutting-edge solutions."
                </Typography>
                <Typography className={classes.quoteAuthor}>
                  — Dr. P. Srinivas Rao, CEO
                </Typography>
              </Box>
            </Fade>
          </Container>
          
          </Box>
        )}
     
      </div>
    );
  };
  

